var render = function render(){
  var _vm$textSettings;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "download-ctn"
  }, [_vm.mode == 'codes' && !_vm.hideActivator ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "raised": "",
      "disabled": !_vm.count
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v(_vm._s(_vm.$t('download')))]) : _vm._e(), _vm.mode == 'single' ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary",
            "icon": ""
          },
          on: {
            "click": _vm.open
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "color": "#15bbf0"
          }
        }, [_vm._v("mdi-qrcode")])], 1)];
      }
    }], null, false, 37656637)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('preview_and_download')))])]) : _vm._e(), _vm.mode == 'product' ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "disabled": _vm.isDisabled,
            "color": "primary",
            "icon": ""
          },
          on: {
            "click": _vm.open
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "color": "#15bbf0"
          }
        }, [_vm._v("mdi-download")])], 1)];
      }
    }], null, false, 1613264683)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('download')))])]) : _vm._e(), _vm.renameTemplateDialog === true ? _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    model: {
      value: _vm.renameTemplateDialog,
      callback: function ($$v) {
        _vm.renameTemplateDialog = $$v;
      },
      expression: "renameTemplateDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t('qr_rename_template')) + " ")]), _c('v-card-text', {
    staticClass: "my-2 pb-0"
  }, [_c('v-text-field', {
    attrs: {
      "maxlength": 200,
      "placeholder": _vm.$t('qr_template_name'),
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.renameName,
      callback: function ($$v) {
        _vm.renameName = $$v;
      },
      expression: "renameName"
    }
  })], 1), _c('v-card-actions', [_c('div', {
    staticClass: "mr-auto"
  }), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeRenameTemplateDialog
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "loading": _vm.renamingTemplate,
      "disabled": !_vm.renameName,
      "text": ""
    },
    on: {
      "click": _vm.renameTemplate
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)], 1) : _vm._e(), _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    model: {
      value: _vm.deleteQrDialog,
      callback: function ($$v) {
        _vm.deleteQrDialog = $$v;
      },
      expression: "deleteQrDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t('delete_confirmation')) + " ")]), _c('v-card-text', {
    staticClass: "my-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('qr_template_delete_confirmation')) + " ")]), _c('v-card-actions', [_c('div', {
    staticClass: "mr-auto"
  }), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.deleteQrDialog = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "red",
      "loading": _vm.deletingTemplate,
      "text": ""
    },
    on: {
      "click": _vm.deleteQrTemplate
    }
  }, [_vm._v(_vm._s(_vm.$t('delete')))])], 1)], 1)], 1), _vm.dialog ? _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "width": _vm.mode === 'single' || _vm.codes.length === 1 ? 800 : 650,
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "pb-2"
  }, [_c('v-card-title', [_vm.mode != 'single' ? _c('span', [_vm._v(_vm._s(_vm.$t('download_format')))]) : _vm._e(), _vm.mode == 'single' ? _c('span', [_vm._v(_vm._s(_vm.$t('preview_and_download')))]) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-stepper', {
    model: {
      value: _vm.step,
      callback: function ($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-stepper-header', [_vm.hasPrefixOptions ? _c('v-stepper-step', {
    attrs: {
      "step": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('select_url_prefix')))]) : _vm._e(), _vm.hasPrefixOptions ? _c('v-divider') : _vm._e(), _c('v-stepper-step', {
    attrs: {
      "step": _vm.hasPrefixOptions ? 2 : 1
    }
  }, [_vm._v(_vm._s(_vm.$t('designing_your_qr_code')))]), _c('v-divider'), _c('v-stepper-step', {
    attrs: {
      "step": _vm.hasPrefixOptions ? 3 : 2
    }
  }, [_vm._v(_vm._s(_vm.$t('file_format')))])], 1), _c('v-stepper-items', [_vm.hasPrefixOptions ? _c('v-stepper-content', {
    staticClass: "prefixes-ctn",
    attrs: {
      "step": "1"
    }
  }, [_c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', [_c('div', {
    staticClass: "d-flex flex-column justify-center"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.formattedPrefixes,
      "label": _vm.$t('all_url_prefixes'),
      "item-text": "displayText",
      "item-value": "prefix",
      "persistent-hint": "",
      "hint": _vm.hasStoredPrefix ? _vm.$t('prefix_used_last_download') : _vm.$t('prefix_will_be_associated_with_codes_selected')
    },
    on: {
      "change": _vm.onPrefixChange
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('div', {
          staticClass: "prefix"
        }, [_vm._v(_vm._s(item.displayText))])];
      }
    }], null, false, 3836696457),
    model: {
      value: _vm.selectedPrefix,
      callback: function ($$v) {
        _vm.selectedPrefix = $$v;
      },
      expression: "selectedPrefix"
    }
  }), _vm.showPrefixConflictMessage && !_vm.hasObsoletePrefix ? _c('span', {
    staticClass: "color-error mt-2"
  }, [_vm._v(_vm._s(_vm.$t('prefix_conflict_message')))]) : _vm._e(), _vm.hasObsoletePrefix && _vm.codes.length === 1 ? _c('span', {
    staticClass: "color-error mt-2"
  }, [_vm._v(_vm._s(_vm.$t('has_deleted_prefix')))]) : _vm._e(), _vm.hasObsoletePrefix && _vm.codes.length > 1 ? _c('span', {
    staticClass: "color-error mt-2"
  }, [_vm._v(_vm._s(_vm.$t('have_deleted_prefix')))]) : _vm._e(), _vm.showPrefixRequiredMessage ? _c('span', {
    staticClass: "color-error mt-2"
  }, [_vm._v(_vm._s(_vm.$t('prefix_required')))]) : _vm._e()], 1)])], 1)], 1) : _vm._e(), _c('v-stepper-content', {
    staticClass: "pb-0",
    attrs: {
      "step": _vm.hasPrefixOptions ? 2 : 1
    }
  }, [_c('v-row', {
    staticClass: "ma-0",
    attrs: {
      "align": "start"
    }
  }, [_c('v-col', {
    staticClass: "pr-0"
  }, [_c('div', {
    staticClass: "scrollable-content"
  }, [_vm.qrTemplates.length ? _c('div', [_c('div', {
    staticClass: "label font-weight-bold pb-1"
  }, [_vm._v(_vm._s(_vm.$t('qr_code_templates')))]), _c('v-select', {
    staticClass: "custom-v-select",
    attrs: {
      "label": _vm.$t('qr_template_select'),
      "items": _vm.qrTemplates,
      "item-value": "id",
      "return-object": "",
      "clearable": "",
      "solo": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('div', {
          staticClass: "select-qr-preview mr-3"
        }, [_c('img', {
          staticClass: "template-qr-preview",
          attrs: {
            "src": _vm.getTemplatePreviewUrl(item)
          }
        }), item.image ? _c('img', {
          staticClass: "template-qr-logo",
          style: {
            backgroundColor: item.background
          },
          attrs: {
            "src": _vm.toDataUrl(item.image)
          }
        }) : _vm._e()]), _c('v-list-item-content', [_c('span', {
          staticClass: "preview-item-title"
        }, [_vm._v(_vm._s(item.name))]), _c('span', {
          staticClass: "preview-item-subtitle mr-3 max-w-295",
          attrs: {
            "title": item.filename
          },
          domProps: {
            "innerHTML": _vm._s(_vm.sanitizeItemFileName(item.filename))
          }
        }), _c('span', {
          staticClass: "preview-item-subtitle",
          domProps: {
            "innerHTML": _vm._s(_vm.sanitizeItemColor(`${item.color} - ${item.background}`))
          }
        })])];
      }
    }, {
      key: "item",
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('div', {
          staticClass: "select-qr-preview mr-3"
        }, [_c('img', {
          staticClass: "template-qr-preview",
          attrs: {
            "src": _vm.getTemplatePreviewUrl(item)
          }
        }), item.image ? _c('img', {
          staticClass: "template-qr-logo",
          style: {
            backgroundColor: item.background
          },
          attrs: {
            "src": _vm.toDataUrl(item.image)
          }
        }) : _vm._e()]), _c('v-list-item-content', [_c('span', {
          staticClass: "preview-item-title"
        }, [_vm._v(_vm._s(item.name))]), _c('span', {
          staticClass: "preview-item-subtitle mr-3",
          domProps: {
            "innerHTML": _vm._s(_vm.sanitizeItemFileName(item.filename))
          }
        }), _c('span', {
          staticClass: "preview-item-subtitle",
          domProps: {
            "innerHTML": _vm._s(_vm.sanitizeItemColor(`${item.color} - ${item.background}`))
          }
        })]), _c('v-list-item-action', [_c('v-btn', {
          attrs: {
            "text": "",
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              return _vm.openRenameTemplateDialog(item);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('rename')) + " ")])], 1), _c('v-list-item-action', {
          staticClass: "ml-1"
        }, [_c('v-btn', {
          attrs: {
            "text": "",
            "color": "red"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteQrTemplateConfirm(item);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('delete')) + " ")])], 1)];
      }
    }], null, false, 565634808),
    model: {
      value: _vm.selectedTemplate,
      callback: function ($$v) {
        _vm.selectedTemplate = $$v;
      },
      expression: "selectedTemplate"
    }
  }), _vm.showTextDownscaledWarning ? _c('div', {
    staticClass: "red--text qr-downscale-warning"
  }, [_vm._v(_vm._s(_vm.$t('qr_text_downscaled_warning')))]) : _vm._e()], 1) : _vm._e(), _c('v-row', [_c('v-col', [_c('div', {
    staticClass: "label font-weight-bold pb-1"
  }, [_vm._v(_vm._s(_vm.$t('qr_color')) + ":")]), _c('color-input', {
    attrs: {
      "color": _vm.form.color
    },
    on: {
      "update:color": function ($event) {
        return _vm.$set(_vm.form, "color", $event);
      }
    }
  })], 1), _c('v-col', [_c('div', {
    staticClass: "label font-weight-bold pb-1"
  }, [_vm._v(_vm._s(_vm.$t('background_color')) + ":")]), _c('color-input', {
    attrs: {
      "color": _vm.form.background
    },
    on: {
      "update:color": function ($event) {
        return _vm.$set(_vm.form, "background", $event);
      }
    }
  })], 1)], 1), _vm.hasContrastIssue ? _c('div', {
    staticClass: "color-error pt-5 d-flex"
  }, [_c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "color": "red"
    }
  }, [_vm._v("mdi-alert")]), _c('div', {
    staticClass: "font-weight-bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('qr_contrast_warning'))
    }
  })], 1) : _vm._e(), _vm.enableQrTextSettings ? _c('text-around-qr-code-settings', {
    ref: "text-around-qr-code-settings",
    attrs: {
      "codes": _vm.codes,
      "product": _vm.product,
      "elabel-data": _vm.elabelData,
      "selected-template": _vm.selectedTemplate,
      "text-positions": _vm.textPositions,
      "qr-scale": _vm.qrScale,
      "text-scale": _vm.textScale
    },
    on: {
      "text-data-updated": _vm.onTextSettingsUpdated,
      "qr-scale-updated": _vm.onQrScaleUpdated,
      "text-scale-updated": _vm.onTextScaleUpdated
    }
  }) : _vm._e()], 1)]), _vm.mode === 'single' || _vm.codes.length === 1 ? _c('v-col', {
    staticClass: "flex-grow-0 preview-col pr-0",
    attrs: {
      "align-self": "center"
    }
  }, [_c('div', {
    staticClass: "label font-weight-bold pb-1 text-center"
  }, [_vm._v(_vm._s(_vm.$t('qr_preview')))]), _c('div', {
    staticClass: "qr-preview d-flex flex-column justify-center"
  }, [_c('div', {
    staticClass: "qr-preview-ctn"
  }, [_c('img', {
    staticClass: "qr",
    attrs: {
      "src": _vm.previewUrl
    }
  }), _vm.form.image && ((_vm$textSettings = _vm.textSettings) === null || _vm$textSettings === void 0 ? void 0 : _vm$textSettings.iconSetting) === 'inside' ? _c('img', {
    staticClass: "logo",
    style: _vm.logoStyle,
    attrs: {
      "src": _vm.toDataUrl(_vm.form.image)
    }
  }) : _vm._e()]), _vm.hasTextOverflow ? _c('div', {
    staticClass: "warn mb-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('qr_text_overflow_warning', {
    count: _vm.textOverflowDetails.filter(function (d) {
      return d.overflow;
    }).length
  })) + " ")]) : _vm._e(), _c('div', {
    staticClass: "mt-auto mb-2"
  }), _c('ImageCropper', {
    attrs: {
      "ratio": 1,
      "label": _vm.$t('upload_logo'),
      "input-key": "qr-logo",
      "show-select-dialog": false
    },
    on: {
      "image-selected": _vm.onImageSelect
    }
  }), _c('div', [_vm.form.image ? _c('v-btn', {
    staticClass: "inset mt-3",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.deleteLogo
    }
  }, [_vm._v(_vm._s(_vm.$t('remove_logo')))]) : _vm._e(), !_vm.form.image ? _c('v-btn', {
    staticClass: "inset mt-3",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.addDefaultLogo
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('qrcode_add_default_logo')) + " ")]) : _vm._e()], 1)], 1)]) : _vm._e()], 1)], 1), _c('v-stepper-content', {
    attrs: {
      "step": _vm.hasPrefixOptions ? 3 : 2
    }
  }, [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "mb-8"
  }, [_c('div', {
    staticClass: "file-format-label font-weight-bold pb-1"
  }, [_vm._v(_vm._s(_vm.$t('choose_file_format')) + ":")]), _c('span', [_vm._v(_vm._s(_vm.$t('choose_file_format_hint')))]), _c('div', {
    staticClass: "mt-2"
  }, _vm._l(_vm.filteredFormats, function (format) {
    return _c('span', {
      key: format,
      staticClass: "pill font-weight-bold mr-2",
      class: {
        'selected': format === _vm.form.format
      },
      on: {
        "click": function ($event) {
          return _vm.selectFormat(format);
        }
      }
    }, [_vm._v(" " + _vm._s(format) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "mb-6"
  }, [_c('div', {
    staticClass: "file-format-label font-weight-bold pb-1"
  }, [_vm._v(_vm._s(_vm.$t('naming_convention')) + ":")]), _c('v-text-field', {
    ref: "filename",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('span', [_vm._v(" ." + _vm._s(_vm.form.format) + " ")])];
      },
      proxy: true
    }], null, false, 1076406608),
    model: {
      value: _vm.form.filename,
      callback: function ($$v) {
        _vm.$set(_vm.form, "filename", $$v);
      },
      expression: "form.filename"
    }
  }), _c('div', {
    staticClass: "hint"
  }, [_vm._v(" " + _vm._s(_vm.$t('naming_convention_hint')) + " ")]), _c('div', _vm._l(_vm.generalFields, function (field) {
    return _c('span', {
      key: `general-field-${field}`,
      staticClass: "pill font-weight-bold mr-2 mb-2",
      class: {
        'selected': _vm.isGeneralFieldSelected(field)
      },
      on: {
        "click": function ($event) {
          return _vm.toggleGeneralField(field);
        }
      }
    }, [_vm._v(_vm._s(field))]);
  }), 0), _c('div', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('tags')) + ":")]), _c('div', _vm._l(_vm.activeScmFields, function (field) {
    return _c('span', {
      key: field.key,
      staticClass: "pill font-weight-bold mr-2 mb-2",
      class: {
        'selected': _vm.isTagSelected(field)
      },
      on: {
        "click": function ($event) {
          return _vm.toggleTag(field);
        }
      }
    }, [_vm._v(_vm._s(field.key === 'scantrust_upload_batch' ? _vm.$t('upload_batch') : field.key))]);
  }), 0)], 1)])], 1)], 1)], 1)], 1)], 1), _c('v-card-actions', [_vm.step === 1 ? _c('v-row', {
    staticClass: "dialog-footer pa-3"
  }, [_c('div', {
    staticClass: "mr-auto"
  }), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _c('v-btn', {
    staticClass: "mr-2",
    on: {
      "click": _vm.handleFirstStepNext
    }
  }, [_vm._v(_vm._s(_vm.$t('next')))])], 1) : _vm._e(), _vm.hasPrefixOptions && _vm.step === 2 ? _c('v-row', {
    staticClass: "dialog-footer pa-3"
  }, [_c('div', {
    staticClass: "mr-auto"
  }), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.step = 1;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('back')))]), _c('v-btn', {
    staticClass: "mr-2",
    on: {
      "click": function ($event) {
        _vm.step = 3;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('next')))])], 1) : _vm._e(), _vm.hasPrefixOptions && _vm.step === 3 || !_vm.hasPrefixOptions && _vm.step === 2 ? _c('v-row', {
    staticClass: "dialog-footer pa-3 align-center"
  }, [_c('div', [_vm.templateToUpdate || _vm.templateToCreate ? _c('v-checkbox', {
    staticClass: "ml-2",
    attrs: {
      "hide-details": "",
      "dense": "",
      "label": _vm.$t('save_as_qr_template')
    },
    model: {
      value: _vm.createTemplateToggle,
      callback: function ($$v) {
        _vm.createTemplateToggle = $$v;
      },
      expression: "createTemplateToggle"
    }
  }) : _vm._e(), (_vm.templateToUpdate || _vm.templateToCreate) && _vm.createTemplateToggle === true ? _c('v-text-field', {
    staticClass: "mt-2 ml-3",
    attrs: {
      "maxlength": 200,
      "placeholder": _vm.$t('qr_template_name'),
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.createName,
      callback: function ($$v) {
        _vm.createName = $$v;
      },
      expression: "createName"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "mr-auto"
  }), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.hasPrefixOptions ? _vm.step = 2 : _vm.step = 1;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('back')))]), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.count > 1000 || _vm.codes.length > 1000
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v(_vm._s(_vm.$t('download')))])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }